// Centralized date/time formatting for NtwanaYam.
// All user-facing dates & times are rendered in South Africa Standard Time
// (Africa/Johannesburg, UTC+2). Backend emits timestamps in UTC (ISO 8601),
// so Intl.DateTimeFormat handles the conversion automatically.

const SA_TIMEZONE = 'Africa/Johannesburg';
const SA_LOCALE = 'en-ZA';

const toDate = (value) => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const formatDateTime = (value, { withSeconds = false } = {}) => {
  const d = toDate(value);
  if (!d) return 'N/A';
  return d.toLocaleString(SA_LOCALE, {
    timeZone: SA_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' } : {}),
    hour12: false,
  });
};

export const formatDate = (value) => {
  const d = toDate(value);
  if (!d) return 'N/A';
  return d.toLocaleDateString(SA_LOCALE, {
    timeZone: SA_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export const formatLongDate = (value) => {
  const d = toDate(value);
  if (!d) return 'N/A';
  return d.toLocaleDateString(SA_LOCALE, {
    timeZone: SA_TIMEZONE,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatTime = (value) => {
  const d = toDate(value);
  if (!d) return 'N/A';
  return d.toLocaleTimeString(SA_LOCALE, {
    timeZone: SA_TIMEZONE,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const SA_TZ = SA_TIMEZONE;
